import React from "react";
import { VehicleMissionStatus } from "Components/OperatorSidePanel/components/VehicleWayStatus/VehicleMissionStatus";
import {
  StatusNameStyled,
  VehicleMissionBodyStyled,
  PlaceInQueueStyled,
  PlaceStyled,
} from "./styles";

/**
 * Wrapper component that uses the original VehicleMissionStatus with custom styles
 */
export const VehicleMissionStatusWithCustomStyles = () => {
  return (
    <VehicleMissionStatus
      customStyles={{
        StatusNameStyled,
        VehicleMissionBodyStyled,
        PlaceInQueueStyled,
        PlaceStyled,
      }}
    />
  );
};

export default VehicleMissionStatusWithCustomStyles;
